import { render, staticRenderFns } from "./AirwallexCard.vue?vue&type=template&id=a6ad79ee&scoped=true&"
import script from "./AirwallexCard.vue?vue&type=script&lang=js&"
export * from "./AirwallexCard.vue?vue&type=script&lang=js&"
import style0 from "./AirwallexCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AirwallexCard.vue?vue&type=style&index=1&id=a6ad79ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ad79ee",
  null
  
)

export default component.exports